import CompatibilityDocsFeature from '../../features/docs/compatibility-feature';

export default function CompatibilityDocsPage() {
  return <CompatibilityDocsFeature />;
}
